export const LOAD_USER_INFO = "[USER_INFO] LOAD_USER_INFO";
export const UPDATE_USER_MOBILE_PHONE = "[USER_INFO]  UPDATE_USER_MOBILE_PHONE";
